import * as ActionTypes from './actionTypes'
import {HttpClient} from '../api/httpClient'
import {addNotesItem , saveNotes } from "../api/setFormData";
import { deleteNotesItem } from '../api/deleteFormData'



export function   createNotesItem(description,createdBy,hotCheckBox,hideLoader, code, noteId = undefined){
    return (dispatch, getState) => {
        let dataSent = addNotesItem(description,createdBy,hotCheckBox, code, noteId)
        HttpClient.post(dataSent)
            .then(response => {
                let payload = response.data.eventMessage
                if(payload.hasOwnProperty("noteId") === true){
                    dispatch({
                        type: ActionTypes.ADD_NOTES_ITEM,
                        payload
                    })
                    hideLoader()
                }
            }).catch(error => {
                console.error("ERROR:: " + error);
                hideLoader()

            })
    }
}

export function updateNotesItem(index, field, payload) {
    return {
        type: ActionTypes.UPDATE_NOTES_ITEM_STATUS,
        payload,
        field,
        index
    }
}





export function saveNotesItem(index, fieldName) {
    return (dispatch, getState) =>{

        let note = getState().NotesReducer.shipmentNotesNodes[index]
        let fieldValue = note[fieldName]
        let response=saveNotes(note.noteId, fieldName, fieldValue);
       
    }
}

export function dontShowNotes(value){
    return {
        type: "DONT_SHOW_NOTES_ITEM",
        value
    }
}


   



 